module.exports = __webpack_public_path__ + "static/media/canTakeQuestion.3f94378a.mp3";